//
import WarehouseModel from '@/models/Warehouse/WhWarehouse'

//
export default ({ g_branch_office_id }) => [
  {
    name: 'wh_warehouse_id',
    type: 'autocomplete-model',
    props: {
      chips: true,
      itemText: 'name',
      itemValue: 'id',
      label: 'Bodega',
      model: WarehouseModel,
      multiple: true,
      paramFilter: {
        g_branch_office_id,
      },
      noObject: true,
    },
  },
  {
    name: 'start',
    type: 'date-field',
    props: {
      label: 'Inicio',
    },
  },
  {
    name: 'end',
    type: 'date-field',
    props: {
      label: 'Termino',
    },
  },
  {
    name: 'alias_name',
    type: 'text-field',
    props: {
      label: 'Alias',
    },
  },
]
